<template>
  <b-card no-body class="gridlay mx-2">
    <b-card-header class="m-0 p-0 h-fixed" align="center">
      <manifest-media-wrapper :manifest="manifest"></manifest-media-wrapper>
    </b-card-header>

    <b-card-body class="pb-3 pt-3 pr-0 text-truncate footer-auto-bottom" >
      <router-link :to="`${ link }`"><h5 class="card-title m-0 ">{{ name }}</h5></router-link>
      <div class="d-flex justify-content-between mt-2">
        <small><span class="text-muted">{{ date | moment("from") }}</span></small>
        <!-- <manifest-cart-add-remove-item :entity="manifest"></manifest-cart-add-remove-item> -->
        <add-manifest-to-cart :manifestId="manifest.manifestId"></add-manifest-to-cart>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import ManifestCartAddRemoveItem from '../Manifest/ManifestCartAddRemoveItem.vue';
import ManifestMediaWrapper from '../Manifest/ManifestMediaWrapper.vue';
import AddManifestToCart from './AddManifestToCart.vue';

export default {
  components: {
    ManifestMediaWrapper,
    ManifestCartAddRemoveItem,
    AddManifestToCart,
  },
  props: {
    manifest: {
      required: true,
    },
    name: {
      required: true,
    },
    link: {
      required: true,
    },
    date: {
      required: true,
    },
  },
};

</script>

<style scoped lang="scss">
.gridlay {
  float: left;
  width:  270px;
  height: 240px;
  object-fit: cover;
}
.h-fixed{
  height: 150px;
  vertical-align: middle;
}
.footer-auto-bottom {
  padding: 0.5rem !important;
}
.pr-0 {
  padding-right: 0px !important;
}
</style>
